import {Icon} from '../../../../icon'
import {Layout} from '../../../../layout'
import {Text} from '../../../../text'
import {usePageContext} from '../../../../page_layout/page_context'
import {t} from '@eitje/bridge'
import {bridge} from '@eitje/bridge'

export const StatusCell = ({getValue, total, ...rest}) => {
	const {core} = usePageContext()
	const status = getValue()
	const color = bridge.coreStatusColor({core, status})
	const label = status ? t(`${core}.statusses.${status}`) : t('common.none')

	return (
		<Layout gap={4}>
			{color && <Icon name="dot-small" fill={color} />}
			<Text> {label} </Text>
			{total}
		</Layout>
	)
}
